module.exports = __webpack_public_path__ + "static/media/account_circle-24px.34fa810a.svg";